import { ECARE_UNSUPPORTED_B2B_BUSINESS_TYPES } from '../constants.js';

const TYPE_ORGANISATION = 'Organisation';
const TYPE_PERSON = 'Person';
const TYPE_EMAIL_CONTACT = 'EmailContact';
const TYPE_CUSTOMER = 'Customer';

export default class CustomerAccountInfo {
  constructor(data) {
    this._data = data;
  }

  /**
   * @return {?string}
   */
  get legalType() {
    return this._data.legalType;
  }

  /**
   * Whether customer is physical entity
   *
   * @return {boolean}
   * @private
   */
  get _isPerson() {
    return this._data['@type'] === TYPE_PERSON;
  }

  /**
   * Whether customer is legal entity, such as company with company registration number or
   * self-employed customer without company registration number.
   *
   * @return {boolean}
   * @private
   */
  get _isOrganisation() {
    return this._data['@type'] === TYPE_ORGANISATION;
  }

  /**
   * Business types of the legal entity customers
   *
   * @returns {?(string[])}
   */
  get businessTypes() {
    if (this._isPerson) {
      return null;
    }
    return this._data?.partyRole.map(partyRole => partyRole.businessType) ?? null;
  }

  /**
   * @return {boolean}
   */
  get isEcareUnsupportedB2BCustomer() {
    return (
      this.businessTypes?.some(businessType =>
        ECARE_UNSUPPORTED_B2B_BUSINESS_TYPES.includes(businessType),
      ) ?? false
    );
  }

  /**
   * Returns `name` for corporate entities and `fullName` for private customers
   *
   * @return {?string}
   */
  get name() {
    if (this._isPerson) {
      return this._data.fullName;
    }
    if (this._isOrganisation) {
      return this._data.name;
    }
    return null;
  }

  /**
   * @return {?string}
   */
  get email() {
    return this._emailContact?.emailAddress;
  }

  /**
   * @return {?object}
   * @private
   */
  get _emailContact() {
    return this._customerParty?.contactableVia.find(
      contact => contact['@type'] === TYPE_EMAIL_CONTACT,
    );
  }

  /**
   * @return {?object}
   * @private
   */
  get _customerParty() {
    return this._data?.partyRole.find(party => party['@type'] === TYPE_CUSTOMER);
  }

  /**
   * @param {string} email
   * @return {[{op: string, path: string, value: string}]}
   */
  static createEmailPatchBody(email) {
    return [
      {
        op: 'replace',
        path: `partyRole/contactableVia[@type='${TYPE_EMAIL_CONTACT}']/emailAddress`,
        value: email,
      },
    ];
  }
}
